
import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AuthRequiredRoute } from './components/AuthRequiredRoute';
import { AdminRoute } from './components/AdminRoute';
import { HomeRoute } from './components/HomeRoute';
import Auth from './pages/Auth';
import ResetPassword from './pages/ResetPassword';

import TreyProfile from './pages/TreyProfile';
import CreateProfile from './pages/CreateProfile';
import Intro from './pages/Intro';
import Index from './pages/Index';
import Engage from './pages/Engage';
import SolutionBounties from './pages/SolutionBounties';
import KnowYourGib from './pages/KnowYourGib';
import Giblet from './pages/Giblet';
import YannisProfile from './pages/YannisProfile';
import IspaiChannel from './pages/IspaiChannel';
import OilGasChannel from './pages/OilGasChannel';
import ChevronCallForSolutions from './pages/ChevronCallForSolutions';
import { ChevronCallForSolutionsDemo } from './pages/ChevronCallForSolutionsDemo';
import ChevronCallForKnowledge from './pages/ChevronCallForKnowledge';
import ChevronCallForDestruction from './pages/ChevronCallForDestruction';
import CurtChannel from './pages/CurtChannel';
import ExxonMobilChannel from './pages/ExxonMobilChannel';
import GsaChannel from './pages/GsaChannel';
import UtthungaChannel from './pages/UtthungaChannel';
import UsaChannel from './pages/UsaChannel';
import DeptEducationChannel from './pages/DeptEducationChannel';
import NoaaChannel from './pages/NoaaChannel';
import Channels from './pages/Channels';
import ShaanProfile from './pages/ShaanProfile';
import AgencySolutions from './pages/AgencySolutions';
import ChannelSolutions from './pages/ChannelSolutions';
import CallForSolutionsForm from './pages/CallForSolutionsForm';
import CallForSolutionsFunctionalArea from './pages/CallForSolutionsFunctionalArea';
import CallForSolutionsBounty from './pages/CallForSolutionsBounty';
import CallForSolutionsCurator from './pages/CallForSolutionsCurator';
import CallForSolutionsBountyDetails from './pages/CallForSolutionsBountyDetails';
import CallForKnowledgeForm from './pages/CallForKnowledgeForm';
import CallForKnowledgeFunctionalArea from './pages/CallForKnowledgeFunctionalArea';
import CallForKnowledgeBounty from './pages/CallForKnowledgeBounty';
import CallForKnowledgeCurator from './pages/CallForKnowledgeCurator';
import CallForKnowledgeBountyDetails from './pages/CallForKnowledgeBountyDetails';
import CallForDestructionForm from './pages/CallForDestructionForm';
import CallForDestructionFunctionalArea from './pages/CallForDestructionFunctionalArea';
import CallForDestructionBounty from './pages/CallForDestructionBounty';
import CallForDestructionCurator from './pages/CallForDestructionCurator';
import CallForDestructionBountyDetails from './pages/CallForDestructionBountyDetails';
import Creators from './pages/Creators';
import PromptArchitectureSprint from './pages/PromptArchitectureSprint';
import CreatorRewards from './pages/CreatorRewards';
import DemoCallForSolutionsForm from './pages/DemoCallForSolutionsForm';
import DemoCallForSolutionsFunctionalArea from './pages/DemoCallForSolutionsFunctionalArea';
import DemoCallForSolutionsBounty from './pages/DemoCallForSolutionsBounty';
import DemoCallForSolutionsBountyDetails from './pages/DemoCallForSolutionsBountyDetails';
import DemoCallForKnowledgeForm from './pages/DemoCallForKnowledgeForm';
import DemoCallForKnowledgeFunctionalArea from './pages/DemoCallForKnowledgeFunctionalArea';
import DemoCallForKnowledgeConnection from './pages/DemoCallForKnowledgeConnection';
import DemoCallForKnowledgeBounty from './pages/DemoCallForKnowledgeBounty';
import DemoCreatorRewards from './pages/DemoCreatorRewards';
import IspaiConnectDemo from './pages/IspaiConnectDemo';
import KarenProfile from './pages/KarenProfile';
import ChrisProfile from './pages/ChrisProfile';
import MorganProfile from './pages/MorganProfile';
import JessProfile from './pages/JessProfile';
import CoreyProfile from './pages/CoreyProfile';
import JimProfile from './pages/JimProfile';
import MikeMosherProfile from './pages/MikeMosherProfile';
import PeteProfile from './pages/PeteProfile';
import MiguelProfile from './pages/MiguelProfile';
import ModularConstructionPage from './pages/ModularConstructionPage';
import JuliaDeRosiProfile from './pages/JuliaDeRosiProfile';
import CharlesHardyProfile from './pages/CharlesHardyProfile';
import HeatherEdwardsProfile from './pages/HeatherEdwardsProfile';
import EnriqueProfile from './pages/EnriqueProfile';
import BillLewisProfile from './pages/BillLewisProfile';
import Waitlist from './pages/Waitlist';
import WaitlistDashboard from './pages/admin/WaitlistDashboard';
import JimEllisProfile from './pages/JimEllisProfile';
import GregSizemoreProfile from './pages/GregSizemoreProfile';
import NathanielSizemoreProfile from './pages/NathanielSizemoreProfile';
import AustinFowlerProfile from './pages/AustinFowlerProfile';
import AiOilGasPresentation from './pages/AiOilGasPresentation';
import KnowledgeBaseDetails from './pages/KnowledgeBaseDetails';
import KnowledgeBaseDocuments from './pages/KnowledgeBaseDocuments';
import KnowledgeBaseConfirmation from './pages/KnowledgeBaseConfirmation';
import KnowledgeBaseReview from './pages/KnowledgeBaseReview';
import CurtKnowledgeBases from './pages/CurtKnowledgeBases';
import MySPAIProfile from './pages/MySPAIProfile';
import CreateMySPAIProfile from './pages/CreateMySPAIProfile';
import EditProfile from './pages/EditProfile';
import MySpaiPerformanceDashboard from './pages/MySpaiPerformanceDashboard';
import ChangePassword from './pages/ChangePassword';
import CreateTeamAccounts from './pages/CreateTeamAccounts';
import CreateUsaTeamAccounts from './pages/CreateUsaTeamAccounts';
import AcceptInvitation from './pages/AcceptInvitation';
import SignupFromInvitation from './pages/SignupFromInvitation';
import ExploreLanding from './pages/ExploreLanding';
import ManageTeam from './pages/admin/ManageTeam';
import CreateWaitlistAccounts from './pages/admin/CreateWaitlistAccounts';
import { KnowledgeBaseViewer } from './pages/KnowledgeBaseViewer';
import AcceptSprintInvitation from './pages/AcceptSprintInvitation';
import EditKnowledgeBase from './pages/EditKnowledgeBase';
import SolutionCreation from './pages/SolutionCreation';
import SolutionReview from './pages/SolutionReview';
import Pricing from './pages/Pricing';
import SubscriptionSuccess from './pages/SubscriptionSuccess';


function App() {
  return (
    <Routes>
      <Route path="/" element={<HomeRoute />} />
      <Route path="/auth" element={<Auth />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/accept-invitation" element={<AcceptInvitation />} />
      <Route path="/signup-from-invitation" element={<SignupFromInvitation />} />
      <Route path="/sprint-invitation/:invitationId/accept" element={<AcceptSprintInvitation />} />
      <Route path="/explore" element={<ExploreLanding />} />
      <Route path="/change-password" element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />
      <Route path="/intro" element={<Intro />} />
      <Route path="/engage" element={<AuthRequiredRoute><Engage /></AuthRequiredRoute>} />
      <Route path="/creators" element={<AuthRequiredRoute><Creators /></AuthRequiredRoute>} />
      <Route path="/admin/manage-team" element={<AdminRoute><ManageTeam /></AdminRoute>} />
      <Route path="/prompt-architecture-sprint" element={<PromptArchitectureSprint />} />
      <Route path="/creator-rewards" element={<CreatorRewards />} />
      
      <Route path="/trey-profile" element={<AuthRequiredRoute><TreyProfile /></AuthRequiredRoute>} />
      <Route path="/yannis-profile" element={<AuthRequiredRoute><YannisProfile /></AuthRequiredRoute>} />
      <Route path="/shaan-profile" element={<AuthRequiredRoute><ShaanProfile /></AuthRequiredRoute>} />
      <Route path="/karen-profile" element={<AuthRequiredRoute><KarenProfile /></AuthRequiredRoute>} />
      <Route path="/chris-profile" element={<AuthRequiredRoute><ChrisProfile /></AuthRequiredRoute>} />
      <Route path="/morgan-profile" element={<AuthRequiredRoute><MorganProfile /></AuthRequiredRoute>} />
      <Route path="/jess-profile" element={<AuthRequiredRoute><JessProfile /></AuthRequiredRoute>} />
      <Route path="/corey-profile" element={<AuthRequiredRoute><CoreyProfile /></AuthRequiredRoute>} />
      <Route path="/jim-profile" element={<AuthRequiredRoute><JimProfile /></AuthRequiredRoute>} />
      <Route path="/mike-mosher-profile" element={<AuthRequiredRoute><MikeMosherProfile /></AuthRequiredRoute>} />
      <Route path="/pete-profile" element={<AuthRequiredRoute><PeteProfile /></AuthRequiredRoute>} />
      <Route path="/miguel-profile" element={<AuthRequiredRoute><MiguelProfile /></AuthRequiredRoute>} />
      <Route path="/julia-derosi-profile" element={<AuthRequiredRoute><JuliaDeRosiProfile /></AuthRequiredRoute>} />
      <Route path="/charles-hardy-profile" element={<AuthRequiredRoute><CharlesHardyProfile /></AuthRequiredRoute>} />
      <Route path="/enrique-profile" element={<AuthRequiredRoute><EnriqueProfile /></AuthRequiredRoute>} />
      <Route path="/bill-lewis-profile" element={<AuthRequiredRoute><BillLewisProfile /></AuthRequiredRoute>} />
      <Route path="/jim-ellis-profile" element={<AuthRequiredRoute><JimEllisProfile /></AuthRequiredRoute>} />
      <Route path="/greg-sizemore-profile" element={<AuthRequiredRoute><GregSizemoreProfile /></AuthRequiredRoute>} />
      <Route path="/nathaniel-sizemore-profile" element={<AuthRequiredRoute><NathanielSizemoreProfile /></AuthRequiredRoute>} />
      <Route path="/austin-fowler-profile" element={<AuthRequiredRoute><AustinFowlerProfile /></AuthRequiredRoute>} />
      <Route path="/create-profile" element={<CreateProfile />} />
      <Route path="/solution-bounties/:userId" element={<SolutionBounties />} />
      <Route path="/know-your-gib" element={<KnowYourGib />} />
      <Route path="/giblet" element={<Giblet />} />
      <Route path="/channels" element={<AuthRequiredRoute><Channels /></AuthRequiredRoute>} />
      <Route path="/ispai-channel" element={<AuthRequiredRoute><IspaiChannel /></AuthRequiredRoute>} />
      <Route path="/oil-gas-channel" element={<AuthRequiredRoute><OilGasChannel /></AuthRequiredRoute>} />
      <Route path="/chevron-call-for-solutions" element={<AuthRequiredRoute><ChevronCallForSolutions /></AuthRequiredRoute>} />
      <Route path="/chevron/call-for-solutions" element={<AuthRequiredRoute><ChevronCallForSolutionsDemo /></AuthRequiredRoute>} />
      <Route path="/chevron-call-for-knowledge" element={<AuthRequiredRoute><ChevronCallForKnowledge /></AuthRequiredRoute>} />
      <Route path="/chevron/call-for-destruction" element={<AuthRequiredRoute><ChevronCallForDestruction /></AuthRequiredRoute>} />
      <Route path="/curt-channel" element={<AuthRequiredRoute><CurtChannel /></AuthRequiredRoute>} />
      <Route path="/curt-knowledge-bases" element={<CurtKnowledgeBases />} />
      <Route path="/modular-construction" element={<ModularConstructionPage />} />
      <Route path="/exxonmobil-channel" element={<AuthRequiredRoute><ExxonMobilChannel /></AuthRequiredRoute>} />
      <Route path="/gsa-channel" element={<AuthRequiredRoute><GsaChannel /></AuthRequiredRoute>} />
      <Route path="/utthunga-channel" element={<AuthRequiredRoute><UtthungaChannel /></AuthRequiredRoute>} />
      <Route path="/usa-channel" element={<AuthRequiredRoute><UsaChannel /></AuthRequiredRoute>} />
      <Route path="/dept-education-channel" element={<AuthRequiredRoute><DeptEducationChannel /></AuthRequiredRoute>} />
      <Route path="/noaa-channel" element={<AuthRequiredRoute><NoaaChannel /></AuthRequiredRoute>} />
      <Route path="/agency-solutions" element={<AgencySolutions />} />
      <Route path="/channel-solutions" element={<ChannelSolutions />} />
      <Route path="/curt-solutions" element={<ChannelSolutions />} />
      <Route path="/chevron-solutions" element={<ChannelSolutions />} />
      <Route path="/ispai-solutions" element={<ChannelSolutions />} />
      <Route path="/exxonmobil-solutions" element={<ChannelSolutions />} />
      <Route path="/gsa-solutions" element={<ChannelSolutions />} />
      <Route path="/dept-education-solutions" element={<ChannelSolutions />} />
      <Route path="/noaa-solutions" element={<ChannelSolutions />} />
      <Route path="/call-for-solutions" element={<CallForSolutionsForm />} />
      <Route path="/call-for-solutions/functional-area" element={<CallForSolutionsFunctionalArea />} />
      <Route path="/call-for-solutions/bounty" element={<CallForSolutionsBounty />} />
      <Route path="/call-for-solutions/curator" element={<CallForSolutionsCurator />} />
      <Route path="/call-for-solutions/bounty-details" element={<CallForSolutionsBountyDetails />} />
      <Route path="/call-for-knowledge" element={<ProtectedRoute><CallForKnowledgeForm /></ProtectedRoute>} />
      <Route path="/call-for-knowledge/functional-area" element={<ProtectedRoute><CallForKnowledgeFunctionalArea /></ProtectedRoute>} />
      <Route path="/call-for-knowledge/bounty" element={<ProtectedRoute><CallForKnowledgeBounty /></ProtectedRoute>} />
      <Route path="/call-for-knowledge/curator" element={<ProtectedRoute><CallForKnowledgeCurator /></ProtectedRoute>} />
      <Route path="/call-for-knowledge/bounty-details" element={<ProtectedRoute><CallForKnowledgeBountyDetails /></ProtectedRoute>} />
      <Route path="/call-for-destruction" element={<CallForDestructionForm />} />
      <Route path="/call-for-destruction/functional-area" element={<CallForDestructionFunctionalArea />} />
      <Route path="/call-for-destruction/bounty" element={<CallForDestructionBounty />} />
      <Route path="/call-for-destruction/curator" element={<CallForDestructionCurator />} />
      <Route path="/call-for-destruction/bounty-details" element={<CallForDestructionBountyDetails />} />
      <Route path="/demo-call-for-solutions" element={<DemoCallForSolutionsForm />} />
      <Route path="/demo-call-for-solutions/functional-area" element={<DemoCallForSolutionsFunctionalArea />} />
      <Route path="/demo-call-for-solutions/bounty" element={<DemoCallForSolutionsBounty />} />
      <Route path="/demo-call-for-solutions/bounty-details" element={<DemoCallForSolutionsBountyDetails />} />
      <Route path="/demo-call-for-knowledge" element={<DemoCallForKnowledgeForm />} />
      <Route path="/demo-call-for-knowledge/functional-area" element={<DemoCallForKnowledgeFunctionalArea />} />
      <Route path="/demo-call-for-knowledge/connection" element={<DemoCallForKnowledgeConnection />} />
      <Route path="/demo-call-for-knowledge/bounty" element={<DemoCallForKnowledgeBounty />} />
      <Route path="/demo-creator-rewards" element={<DemoCreatorRewards />} />
      <Route path="/ispai-connect-demo" element={<IspaiConnectDemo />} />
      <Route path="/ai-oil-gas-presentation" element={<AiOilGasPresentation />} />
      <Route path="/knowledge-base-details" element={<KnowledgeBaseDetails />} />
      <Route path="/knowledge-base-review" element={<ProtectedRoute><KnowledgeBaseReview /></ProtectedRoute>} />
      <Route path="/knowledge-base/:id" element={<AuthRequiredRoute><KnowledgeBaseViewer /></AuthRequiredRoute>} />
      <Route path="/edit-knowledge-base/:id" element={<ProtectedRoute><EditKnowledgeBase /></ProtectedRoute>} />
      <Route path="/knowledge-base-documents" element={<ProtectedRoute><KnowledgeBaseDocuments /></ProtectedRoute>} />
      <Route path="/knowledge-base-confirmation" element={<ProtectedRoute><KnowledgeBaseConfirmation /></ProtectedRoute>} />
      <Route path="/myspai-profile" element={<ProtectedRoute><MySPAIProfile /></ProtectedRoute>} />
      <Route path="/myspai-profile/:username" element={<Navigate to="/creators" replace />} />
      <Route path="/myspai-profile/:username/edit" element={<Navigate to="/edit-profile" replace />} />
      <Route path="/create-myspai-profile" element={<ProtectedRoute><CreateMySPAIProfile /></ProtectedRoute>} />
      <Route path="/edit-profile" element={<ProtectedRoute><EditProfile /></ProtectedRoute>} />
      <Route path="/create-team-accounts" element={<CreateTeamAccounts />} />
      <Route path="/create-usa-team-accounts" element={<CreateUsaTeamAccounts />} />
      <Route path="/solution-creation" element={<AuthRequiredRoute><SolutionCreation /></AuthRequiredRoute>} />
      <Route path="/solution-review" element={<ProtectedRoute><SolutionReview /></ProtectedRoute>} />
      <Route path="/waitlist" element={<Waitlist />} />
      <Route path="/heather-edwards-profile" element={<HeatherEdwardsProfile />} />
      <Route path="/charles-hardy-profile" element={<CharlesHardyProfile />} />
      <Route path="/admin/waitlist" element={<AdminRoute><WaitlistDashboard /></AdminRoute>} />
      <Route path="/admin/create-waitlist-accounts" element={<AdminRoute><CreateWaitlistAccounts /></AdminRoute>} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/subscription/success" element={<SubscriptionSuccess />} />
    </Routes>
  );
}

export default App;
